"use strict";

var _toConsumableArray = require("/codebuild/output/src1330877900/src/node_modules/@babel/runtime/helpers/toConsumableArray.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryJobs = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.parse-float.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
var _stringFunctions = require("./stringFunctions");
var _math = require("./math");
var queryJobs = function queryJobs(jobs, term, latitude, longitude, range, indexes, units, states, shiftTypes, cities, categories) {
  var tempList = []; // If search term is empty, return all jobs.
  // Lowercase the term.

  term = term.toLowerCase(); // Remove accents.

  term = (0, _stringFunctions.removeAccents)(term);
  var allJobs = _toConsumableArray(jobs);
  if (term === '' && !latitude && !longitude && states.length === 0 && cities.length === 0 && shiftTypes.length === 0 && categories.length === 0) {
    console.log("Categories: ", categories);
    return allJobs;
  } // Replace punctuating between words with spaces.

  term = term.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, ' '); // Split search words, delimited by spaces

  var terms = term.split(' '); // Remove any terms that are empty strings. ""

  terms = terms.filter(function (e) {
    return e !== '';
  });
  for (var job in allJobs) {
    if (allJobs.hasOwnProperty(job)) {
      // If lat/lng is given, check if the job is close enough to show.
      if (latitude && longitude) {
        var userLat = parseFloat(latitude);
        var userLng = parseFloat(longitude);
        if (userLat && userLng) {
          var _allJobs$job, _allJobs$job2;
          if ((_allJobs$job = allJobs[job]) !== null && _allJobs$job !== void 0 && _allJobs$job.lat && (_allJobs$job2 = allJobs[job]) !== null && _allJobs$job2 !== void 0 && _allJobs$job2.lng) {
            var _allJobs$job3, _allJobs$job4;
            var jobLat = parseFloat((_allJobs$job3 = allJobs[job]) === null || _allJobs$job3 === void 0 ? void 0 : _allJobs$job3.lat);
            var jobLng = parseFloat((_allJobs$job4 = allJobs[job]) === null || _allJobs$job4 === void 0 ? void 0 : _allJobs$job4.lng);
            if (!jobLat || !jobLng) continue;
            var dist = (0, _math.distance)(userLat, userLng, jobLat, jobLng, units);
            allJobs[job].distance = dist;
            if (dist > range) {
              continue;
            }
          }
        }
      }
      if (states.length > 0) {
        var addJob = false;
        for (var state in states) {
          var _allJobs$job5;
          if (String((_allJobs$job5 = allJobs[job]) === null || _allJobs$job5 === void 0 ? void 0 : _allJobs$job5.state) === states[state]) addJob = true;
        }
        if (!addJob) continue;
      }
      if (shiftTypes.length > 0) {
        var _addJob = false;
        for (var shift in shiftTypes) {
          var _allJobs$job6;
          if (String((_allJobs$job6 = allJobs[job]) === null || _allJobs$job6 === void 0 ? void 0 : _allJobs$job6.fullTime) === shiftTypes[shift]) _addJob = true;
        }
        if (!_addJob) continue;
      }
      if (categories.length > 0) {
        var _addJob2 = false;
        for (var category in categories) {
          var _allJobs$job7;
          if (String((_allJobs$job7 = allJobs[job]) === null || _allJobs$job7 === void 0 ? void 0 : _allJobs$job7.category) === categories[category]) _addJob2 = true;
        }
        if (!_addJob2) continue;
      }
      if (cities.length > 0) {
        var _addJob3 = false;
        for (var city in cities) {
          var _allJobs$job8;
          if (String((_allJobs$job8 = allJobs[job]) === null || _allJobs$job8 === void 0 ? void 0 : _allJobs$job8.city) === cities[city]) _addJob3 = true;
        }
        if (!_addJob3) continue;
      }
      var indexWeight = 0;
      var data = jobs[job]; // For each index

      for (var index in indexes) {
        if (indexes.hasOwnProperty(index)) {
          // Check if the jobData has that index.
          if (data.hasOwnProperty(indexes[index].name)) {
            // Make sure all terms are included in that index.
            // let allTermsIncluded = false;
            // For each search term
            for (var _term in terms) {
              if (terms.hasOwnProperty(_term)) {
                // If the index includes the term.
                if (data[indexes[index].name].toLowerCase().includes(terms[_term])) {
                  indexWeight = indexWeight + 100 * indexes[index].factor;
                }
              }
            }
          }
        }
      }
      if (indexWeight > 0) {
        data.weight = indexWeight;
        tempList.push(data);
      } else if (term === "") {
        tempList.push(data);
      }
    }
  }
  return tempList;
};
exports.queryJobs = queryJobs;